var _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 19.75C23.3284 19.75 24 20.4216 24 21.25V22.75C24 23.5784 23.3284 24.25 22.5 24.25H1.5C0.671573 24.25 2.41598e-08 23.5784 0 22.75V21.25C0 20.4216 0.671573 19.75 1.5 19.75H4.5L5.55566 10.2529C5.80895 7.97419 7.73459 6.25017 10.0273 6.25H13.9727C16.2654 6.25017 18.1911 7.97419 18.4443 10.2529L19.5 19.75H22.5Z",
    fill: "#4880FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 9,
    y: 25.75,
    width: 6,
    height: 6,
    rx: 2.25,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.173224,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 18.25C25.9706 18.25 30 14.2206 30 9.25C30 4.27944 25.9706 0.25 21 0.25C16.0294 0.25 12 4.27944 12 9.25C12 14.2206 16.0294 18.25 21 18.25Z",
    fill: "#FF4F4F",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 17C25.4183 17 29 13.4183 29 9C29 4.58172 25.4183 1 21 1C16.5817 1 13 4.58172 13 9C13 13.4183 16.5817 17 21 17Z",
    fill: "#FF4F4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.912 13.12C20.216 13.12 19.62 12.956 19.124 12.628C18.636 12.292 18.264 11.812 18.008 11.188C17.752 10.564 17.624 9.808 17.624 8.92C17.624 7.96 17.768 7.148 18.056 6.484C18.344 5.812 18.76 5.3 19.304 4.948C19.848 4.596 20.5 4.42 21.26 4.42C21.556 4.42 21.852 4.46 22.148 4.54C22.452 4.612 22.736 4.72 23 4.864C23.272 5 23.512 5.168 23.72 5.368L23.216 6.52C22.92 6.248 22.604 6.048 22.268 5.92C21.932 5.784 21.588 5.716 21.236 5.716C20.892 5.716 20.584 5.78 20.312 5.908C20.048 6.028 19.824 6.212 19.64 6.46C19.456 6.7 19.316 7.004 19.22 7.372C19.132 7.732 19.088 8.152 19.088 8.632V9.532H18.944C19.008 9.124 19.14 8.776 19.34 8.488C19.548 8.192 19.812 7.968 20.132 7.816C20.452 7.656 20.808 7.576 21.2 7.576C21.688 7.576 22.12 7.692 22.496 7.924C22.872 8.156 23.168 8.476 23.384 8.884C23.6 9.292 23.708 9.76 23.708 10.288C23.708 10.832 23.588 11.32 23.348 11.752C23.116 12.176 22.788 12.512 22.364 12.76C21.948 13 21.464 13.12 20.912 13.12ZM20.828 11.896C21.116 11.896 21.368 11.832 21.584 11.704C21.808 11.576 21.98 11.396 22.1 11.164C22.22 10.924 22.28 10.652 22.28 10.348C22.28 10.036 22.22 9.764 22.1 9.532C21.98 9.3 21.808 9.12 21.584 8.992C21.368 8.856 21.116 8.788 20.828 8.788C20.54 8.788 20.288 8.856 20.072 8.992C19.856 9.12 19.684 9.3 19.556 9.532C19.436 9.764 19.376 10.036 19.376 10.348C19.376 10.652 19.436 10.924 19.556 11.164C19.684 11.396 19.856 11.576 20.072 11.704C20.288 11.832 20.54 11.896 20.828 11.896Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.01fca48d55f978ece900956deb7be2df.svg";
export { ForwardRef as ReactComponent };